// Copyright (c) 2025. CYBERKOALA LLC. All Rights Reserved.
// Proprietary license.

import { useContext } from 'react';
import { StatusContext } from '@/context/status-context/status-context.tsx';

export const useStatus = () => {
  return useContext(StatusContext);
};
